import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ManagerAccountingCash from '@/pages/manager-accounting-cash/ManagerAccountingCash.vue';

export default {
  path: '/manager-accounting-cash',
  name: 'ManagerAccountingCash',
  components: {
    mainContent: ManagerAccountingCash,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'manager-accounting-cash',
    },
    breadcrumb: {
      title: 'Controle de Caixa',
      paths: [{ title: 'Gerenciamento' }],
    },
  },
};
